export default {"src":"/_next/static/media/eyes.15f49cd1.svg","height":43,"width":48,"blurWidth":0,"blurHeight":0};